import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get the color classes for a role badge
 */
export function getRoleBadgeColor(role: string): string {
  switch (role) {
    case 'CLUB_ADMIN':
      return 'bg-red-500/10 text-red-500'
    case 'COMPETITION_SECRETARY':
      return 'bg-blue-500/10 text-blue-500'
    case 'JUDGE':
      return 'bg-purple-500/10 text-purple-500'
    case 'PROJECTIONIST':
      return 'bg-green-500/10 text-green-500'
    case 'AUDIENCE_VOTER':
      return 'bg-orange-500/10 text-orange-500'
    case 'PLATFORM_OWNER':
      return 'bg-yellow-500/10 text-yellow-500'
    case 'MEMBER':
      return 'bg-gray-500/10 text-gray-500'
    case 'GUEST':
      return 'bg-teal-500/10 text-teal-600'
    default:
      return 'bg-gray-500/10 text-gray-500'
  }
}

export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function generateJoinCode(): string {
  return Math.random().toString(36).substring(2, 8).toUpperCase()
}

/**
 * Format a date consistently for display (same on server and client)
 */
export function formatDate(date: Date | string | null | undefined): string {
  if (!date) return 'N/A'
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}
